import axios from 'axios'
import apiUrl from '../../api.config'

const CHAT_API_URL = apiUrl + 'chat'

export default {
    chat(message){
        return axios.post(CHAT_API_URL + '/chat', { message }, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    }
}